import React from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { VectorRightIcon, VectorLeftIcon } from 'uikit'
import { Farm } from 'state/types'

const PaginationContainer = styled.div`
  display: flex;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  color: #FFFFFF;
  justify-content: center;
  padding-top: 12px;
  padding-bottom: 24px;
`

const StyledVectorLeft = styled(VectorLeftIcon)`
  cursor: pointer;
`

const StyledVectorRight = styled(VectorRightIcon)`
  cursor: pointer;
`

export interface FarmWithStakedValue extends Farm {
  apr?: number
  lpRewardsApr?: number
  liquidity?: BigNumber
}

interface PaginationProps {
  current: number
  pages: number
  nextPage: () => void
  prevPage: () => void
}

const Pagination: React.FC<PaginationProps> = ({ current, pages, nextPage, prevPage }) => {

  const onClickPrev = () => {
    prevPage()
  }
  const onClickNext = () => {
    nextPage()
  }

  return (
    <PaginationContainer>
      <StyledVectorLeft
        onClick={() => onClickPrev()}
        opacity={current === 1 ? 0.5 : 1}
        mr={16}
      />
      Page {current} of {pages}
      <StyledVectorRight
        onClick={() => onClickNext()}
        opacity={current === pages ? 0.5 : 1}
        ml={16}
      />
    </PaginationContainer>
  )
}

export default Pagination
